/**
 * RouteTransitionFallback — carga "entre pasos" SIN splash de logo.
 * ───────────────────────────────────────────────────────────────────────────
 * BUG ENTRADA · Parte 3 (2026-06-08): el splash con el wordmark "PrimeLab" +
 * bolita (PLLoader) NO debe aparecer en transiciones intermedias ("la app
 * pensando entre pasos"). Antes era el fallback de <Suspense> y de los guards,
 * así que CADA navegación entre rutas lazy mostraba el logo.
 *
 * Patrón correcto del DS: fondo cream del Ascenso + una sola bolita terracota
 * con respiración sutil (mismo motivo visual que AscensoScreenPL · cima del
 * arco), sin wordmark. Honesto, quieto, sin marca tipográfica entre pasos.
 * Respeta prefers-reduced-motion (sin animación si el usuario lo pide).
 */

import { motion } from 'framer-motion'
import usePrefersReducedMotion from '../../design-system/motion/usePrefersReducedMotion'

export default function RouteTransitionFallback() {
  const reduced = usePrefersReducedMotion()
  return (
    <div
      role="status"
      aria-label="Cargando"
      data-theme="light"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--prime-cream, #FAF9F5)',
        colorScheme: 'light',
        zIndex: 40,
      }}
    >
      <motion.span
        aria-hidden="true"
        style={{
          display: 'block',
          width: 12,
          height: 12,
          borderRadius: '50%',
          background: 'var(--prime-terracota, #CC785C)',
        }}
        initial={{ opacity: reduced ? 0.6 : 0.4, scale: 1 }}
        animate={reduced ? { opacity: 0.6 } : { opacity: [0.4, 1, 0.4], scale: [1, 1.12, 1] }}
        transition={reduced ? { duration: 0 } : { duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  )
}
